<!-- ADQ看板-广告 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<!-- <a-menu-item key="1"> <a-icon type="align-right" />开启</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />暂停</a-menu-item>
						<a-menu-item key="3"> <a-icon type="user-delete" />删除</a-menu-item> -->
						<a-menu-item key="5"> <a-icon type="align-right" />修改回传参数</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
				
			<div class="jl-screen-box">
				<div class="screen-label" style="margin-right: 7px;">精简模式</div>
				<a-switch :checked="jj_checked" default-checked @change="onJJChange"  checked-children="开" un-checked-children="关"/>
			</div>
			
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    {{type_button_text}}
					<a-menu slot="overlay" @click="handleMenuClickB">
						<a-menu-item key="1"> <a-icon type="align-right" />全部</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />只看有消耗</a-menu-item>
						<a-menu-item key="3"> <a-icon type="align-right" />只看有展示</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<!-- <div style="display: flex;align-items: center;padding-right: 10px;"> -->
				<div class="jl-screen-box">
					<a-range-picker style="width:200px;" @change="onChangeDate" :allowClear="false"
					:locale="locale" 
					:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
				</div>
				
				<div v-if="Object.keys(personChargeList).length > 0" class="jl-screen-box">
					<a-select
						mode="multiple" 
						style="min-width: 135px;max-width: 390px;"
						placeholder="请选择投手"
						@change="handleChangeA"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						:value="r_admin_id"
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_account_id" allowClear placeholder="请输入广告账户ID" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_account_name" allowClear placeholder="请输入广告账户名称" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_plan_campaign_id" allowClear placeholder="请输入计划ID" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_campaign_name" allowClear placeholder="请输入计划名称" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_adgroup_id" allowClear placeholder="请输入广告ID" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_adgroup_name" allowClear placeholder="请输入广告名称" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 220px"
						placeholder="广告状态"
						@change="handleChangeF"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option v-for="(item,index) in ggStatusData" :key="index" :value="item.value">{{item.label}}</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 130px"
						placeholder="广告操作状态"
						@change="handleChangeG"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						
						<a-select-option value="AD_STATUS_NORMAL">
						  启用
						</a-select-option>
						<a-select-option value="AD_STATUS_SUSPEND">
						  暂停
						</a-select-option>
					</a-select>
				</div>
				
				<a-button @click="searchButton('button')" :loading="search_button_loading" class="jl-screen-box" type="primary" icon="search">搜索</a-button>
				<a-button @click="exportButton()" class="jl-screen-box" type="primary">导出</a-button>
			<!-- </div> -->
		</div>
	</div>
	</div>
	
	<div style="">
		<MPggTable @table-th-click="tableThClick" :rableTitle="rableTitle" 
		:tableShowData="tableShowData" :tableSumData="tableSumData" 
		:table_scroll_width="table_scroll_width" :jj_checked="jj_checked" 
		:indeterminate="indeterminate" :checkAll="checkAll" :table_null_width="table_null_width" 
		:page_type="'adq'" 
		@click-All-Checkbox="onCheckAllChange" @click-Checkbox="onChangeCheckbox"
		@status-Checkbox="statusCheckbox" @set-Plan-Hcbl="setPlanHcbl"
		@td-handle="tdHandle"></MPggTable>
	</div>
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	
	<!-- 批量删除 -->
	<a-modal :visible="dl_modal" title="确认要删除这些吗？" okType="danger" width="700px"
	  okText="删除" cancelText="取消"
	  @ok="dlOk" @cancel="dlCancel" :confirmLoading="dl_loading">
	    <div style="">
			<div style="margin-bottom: 10px;">已选的删除项（广告计划名称）：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 15px;" class="">
					<div style="width: 80px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 195px;">{{item.plan_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 回传比例侧边栏 -->
	<txHcDrawer ref="txHcRef" @hc-request="hcRequestD"></txHcDrawer>
	
	<!-- 小时统计 -->
	<JLjhHour ref="getDrawerHour" :page_type="'MPgg'" :show_name="h_drawer_name" :show_id="h_drawer_id"
	@hour-loading-handle="hourLoadingHandle" @hour-drawer-close="hourDrawerClose"></JLjhHour>
	<!-- 天统计 -->
	<JLjhDay ref="getDrawerDay" :page_type="'MPgg'" :show_name="h_drawer_name" :show_id="h_drawer_id"
	@hour-loading-handle="hourLoadingHandle" @hour-drawer-close="hourDrawerClose"></JLjhDay>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { MPggList , putDataMenu, JLjhEditStatus, putUserList, JLjhReportConfig, JLjhPlReportConfig, MPggExport, MPggReportConfig } from '@/request/api'
import MPggTable from '@/components/ADQtable/ADQggTable.vue'
import txHcDrawer from '../components/txHcDrawer.vue'
import JLjhHour from '@/components/JLtable/JLjhHour.vue'
import JLjhDay from '@/components/JLtable/JLjhDay.vue'
export default {
	name: 'ADQgg_',
	components: {
		MPggTable, txHcDrawer, JLjhHour, JLjhDay
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			jj_checked: true, // 精简模式，默认打开
			
			selectGgData: [], // 选择广告账户
			s_page: 1,
			s_limit: 100,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			blurGgData: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"广告名称",width:110, sort_status:0, type:"adgroup_name", text_right: false,sort_:90,sort_control: false, show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"操作",width:160, sort_status:0, type:"cz", text_right: false,sort_:88,sort_control: false, show_control: true,},
				{title:"广告状态",width:80, sort_status:0, type:"system_status", text_right: false,sort_:88,sort_control: false, show_control: true,},
				{title:"出价",width:85, sort_status:0, type:"bid_amount", text_right: true,sort_:88,sort_control: false, show_control: true,},
				// 以下为数据项
				{title:"消耗",width:85, sort_status:0, type:"cost", text_right: true,sort_:87,sort_control: true, show_control: true,},
				{title:"展示数",width:85, sort_status:0, type:"show", text_right: true,sort_:86,sort_control: true, show_control: false,},
				{title:"ecpm",width:80, sort_status:0, type:"avg_show_cost", text_right: true,sort_:85,sort_control: true, show_control: false,},
				{title:"点击数",width:80, sort_status:0, type:"click", text_right: true,sort_:39,sort_control: true, show_control: false,},
				{title:"平均点击单价",width:80, sort_status:0, type:"avg_click_cost", text_right: true,sort_:38,sort_control: true, show_control: false,},
				{title:"点击率",width:80, sort_status:0, type:"ctr", text_right: true,sort_:37,sort_control: true, show_control: false,},
				
				{title:"公众号关注数(非微信)",width:110, sort_status:0, type:"from_follow_uv", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"公众号关注成本(非微信)",width:110, sort_status:0, type:"from_follow_cost", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"公众号关注数(微信)",width:110, sort_status:0, type:"follow_count", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"公众号关注成本(微信)",width:110, sort_status:0, type:"follow_cost", text_right: true,sort_:36,sort_control: true, show_control: true,},
				
				{title:"转化数",width:80, sort_status:0, type:"conversions_count", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"平均转化成本",width:80, sort_status:0, type:"conversions_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"转化率",width:80, sort_status:0, type:"conversions_rate", text_right: true,sort_:35,sort_control: true, show_control: false,},
				
				{title:"当天总充值金额",width:85, sort_status:0, type:"eff_total_pay_money", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天分成金额",width:85, sort_status:0, type:"eff_total_left_money", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充分成金额",width:85, sort_status:0, type:"eff_total_left_money_fisrt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天总ROI",width:70, sort_status:0, type:"eff_roi", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充ROI",width:80, sort_status:0, type:"eff_roi_first", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"当天订单笔数",width:80, sort_status:0, type:"eff_total_order_cnt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天充值用户数",width:90, sort_status:0, type:"eff_total_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天充值用户成本",width:90, sort_status:0, type:"eff_total_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"ARPU",width:80, sort_status:0, type:"arpu", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户数",width:80, sort_status:0, type:"eff_report_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户成本",width:80, sort_status:0, type:"eff_report_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"广告回传比例",width:250, sort_status:0, type:"report_config", text_right: false,sort_:35,sort_control: false, show_control: true,},
				// 以下是基本信息
				{title:"广告ID",width:120, sort_status:0, type:"adgroup_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"计划ID",width:120, sort_status:0, type:"campaign_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"计划名称",width:130, sort_status:0, type:"campaign_name", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"账户名称",width:150, sort_status:0, type:"account_name", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"账户ID",width:110, sort_status:0, type:"account_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"创建时间",width:150, sort_status:0, type:"created_time", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"更新时间",width:150, sort_status:0, type:"last_modified_time", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"投手",width:120, sort_status:0, type:"admin_list", text_right: false,sort_:35,sort_control: false, show_control: true,},
			],
			tableShowData: [], // 显示表格内容
			tableSumData: {}, // 总计

			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_sort_field: "", // 排序参数
			r_sort_type: "", // 排序类型
			r_admin_id: [], // 选择投手
			r_adv_id: [], // 选择的广告账户
			r_status: "", // 广告状态
			r_system_status: "", // 广告操作状态
			r_export: "", // 是否导出，为1表示导出
			
			r_account_id: "", // 广告账户ID
			r_account_name: "", // 广告账户名称
			r_plan_campaign_id: "", // 计划ID
			r_campaign_name: "", // 计划名称
			r_adgroup_id: "", // 广告ID
			r_adgroup_name: "", // 广告名称
			
			filterData: {
				op_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				book_type: {
					list: [{}],
				}
			}, 
			ggStatusData: [
				{label: "未知状态",value: "STATUS_UNKNOWN"},
				{label: "审核中",value: "STATUS_PENDING"},
				{label: "审核不通过",value: "STATUS_DENIED"},
				{label: "冻结",value: "STATUS_FROZEN"},
				{label: "暂停中",value: "STATUS_SUSPEND"},
				{label: "未到投放时间",value: "STATUS_READY"},
				{label: "投放中",value: "STATUS_ACTIVE"},
				{label: "投放结束",value: "STATUS_STOP"},
				{label: "准备中",value: "STATUS_PREPARE"},
				{label: "已删除",value: "STATUS_DELETED"},
				{label: "广告被暂停（账户资金被冻结）",value: "STATUS_ACTIVE_ACCOUNT_FROZEN"},
				{label: "广告被暂停（账户余额不足）",value: "STATUS_ACTIVE_ACCOUNT_EMPTY"},
				{label: "广告被暂停（账户达日限额）",value: "STATUS_ACTIVE_ACCOUNT_LIMIT"},
				{label: "广告被暂停（推广计划达日限额）",value: "STATUS_ACTIVE_CAMPAIGN_LIMIT"},
				{label: "广告被暂停（推广计划暂停）",value: "STATUS_ACTIVE_CAMPAIGN_SUSPEND"},
				{label: "广告被暂停（广告达日限额）",value: "STATUS_ACTIVE_AD_LIMIT"},
				{label: "部分待投放",value: "STATUS_PART_READY"},
				{label: "部分投放中",value: "STATUS_PART_ACTIVE"},
			],
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量删除弹窗
			dl_modal: false,
			dl_loading: false,
			
			personChargeList: {}, // 投手
			
			type_button_text: "全部", // 只看有消耗/只看有展示的按钮文案
			type_button_key: '1', // 当前选中状态的key，避免点击同样的选项重复请求。默认是全部
			have_cost: "", // 只看有消耗
			have_show: "", // 只看有展示
			
			role_control: [], // 用户权限控制
			
			h_drawer_name: "", // 广告名称，仅用于展示，不用于请求
			h_drawer_id: "", // 广告ID
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			if(res.show_control){
				nn = nn + res.width
			}
		})
		that.table_scroll_width = nn + 30 + 30
		if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
		else { that.table_null_width = that.table_scroll_width - 60 }
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 接收从计划页面传过来的参数
		if(this.$route.params){
			if(this.$route.params.jump_id){
				this.r_account_id = this.$route.params.jump_id
				
			}
			
		}
		
		// 获取1天前日期
		// that.startTime = this.$getBeforeDay(1)
		// 获取当天日期
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay()
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
		
		
		// 搜索
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 精简模式
		onJJChange(e){
			console.log(!e);
			
			this.rableTitle.forEach(res=>{
				// console.log(res);
				if(res.title == "展示数" || res.title == "ecpm" || res.title == "点击数" || res.title == "平均点击单价" || res.title == "点击率" || res.title == "转化率" || res.title == "当天总充值金额" || res.title == "当天首充分成金额" || res.title == "当天订单笔数"){
					if(e){ // 精简模式打开
						res.show_control = false
					}
					else {  // 精简模式关闭，显示内容
						res.show_control = true
					}
					
				}
			})
			
			let nn = 0
			this.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			this.table_scroll_width = nn + 30 + 30
			
			this.jj_checked = e
			
			// 给母页面的tab传递粘性定位用的参数
			this.$bus.$emit("stickyData", this.table_scroll_width);
		},
		handleChangeA(e){ // 选择投手
			console.log(e);
			// 未设置的选项与其他选项不可以同时选，所以这里要加限制
			if(e.length > 1 && e.indexOf('-1') > -1){
				this.$message.warning('未设置与其他选项不能同时选择');
			}
			else {
				this.r_admin_id = e
			}
		},
		
		handleChangeF(e){ // 广告状态
			console.log(e);
			this.r_status = e
		},
		handleChangeG(e){ // 广告操作状态
			console.log(e);
			this.r_system_status = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
				
				// 这个页面经常需要通过消费的排序或其他排序来看数据，所以这里清空的话，每次搜索就要重新点排序，麻烦，干脆注释
				// 排序的状态重置
				// that.r_sort_field = ''
				// that.r_sort_type = ''
				// that.rableTitle.forEach(res=>{
				// 	res.sort_status = 0 // 排序的状态重置
				// })
			}
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_time: that.startTime.replace(/-/g, ''),
				end_time: that.endTime.replace(/-/g, ''),
				is_wechat_account: "2", // 账户类型，2表示ADQ
				
				advertiser_id: that.r_adv_id,
				campaign_id: that.r_campaign_id,
				plan_id: that.r_plan_id, // 广告计划
			}
			if(that.r_account_id){ // 广告账户ID
				r_data.account_id = that.r_account_id
			}
			if(that.r_account_name){ // 广告账户名称
				r_data.account_name = that.r_account_name
			}
			if(that.r_plan_campaign_id){ // 计划ID
				r_data.campaign_id = that.r_plan_campaign_id
			}
			if(that.r_campaign_name){ // 计划名称
				r_data.campaign_name = that.r_campaign_name
			}
			if(that.r_adgroup_id){ // 广告ID
				r_data.adgroup_id = that.r_adgroup_id
			}
			if(that.r_adgroup_name){ // 广告名称
				r_data.adgroup_name = that.r_adgroup_name
			}
			
			// 超级管理、投放管理可以有 投手
			if(Object.keys(that.personChargeList).length > 0){
				r_data.admin_id = that.r_admin_id // 选择投手
			}
			if(that.r_status){ // 广告状态
				r_data.status = that.r_status
			}
			if(that.r_system_status){ // 广告操作状态
				r_data.system_status = that.r_system_status
			}
			
			// 如有排序字段就加上
			if(that.r_sort_field){ 
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			// 只看有消耗/只看有展示 按钮
			if(that.have_cost == "1"){ // 消耗
				r_data.have_cost = "1"
			}
			else if(that.have_show == "1"){ // 展示
				r_data.have_show = "1"
			}
			// 是否导出
			if(that.r_export == "1"){
				r_data.export = "1"
			}
			// 正常搜索
			if(that.r_export != "1"){
				console.log("r_data",r_data);
				MPggList(r_data).then(res=>{
					console.log('搜索',res);
					
					// 因为批量操作的开启和暂停没有弹窗提示选了哪些内容，所以就不支持翻页也存着上一个页面存的内容
					// 每次请求重置批量选择的状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					that.r_export = ""
					
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						if(type == "export"){ // 表示导出
							that.$message.success(res.data.msg || "导出成功");
							that.search_button_loading = false
						}
						else {
							let data = res.data.data.data
							data.forEach(res=>{
								res.checked = false // 用于多选和单选
								res.popover_clicked = false // 表格-操作栏的气泡卡片
								if(res.status == 'AD_STATUS_NORMAL'){
									res.status_checked = true
								}
								else { // 暂停
									res.status_checked = false
								}
							})
							
							that.search_button_loading = false
							
							that.$message.success('搜索成功');
							
							that.tableSumData = res.data.data.sum
							that.table_total = res.data.data.total
							that.tableShowData = data
						}
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
					else {
						
						that.search_button_loading = false
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
				})
				.catch(err=>{
					console.log("err",err);
					// 重置状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					
					that.search_button_loading = false
					that.r_export = ""
					
					that.$message.error('搜索失败，请检查网络状态')
					
					// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					setTimeout(()=>{
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					},300)
				})
			}
			else if(that.r_export == "1"){
				MPggExport(r_data).then(res=>{
					console.log('导出',res);
					
					that.r_export = ""
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
				})
			}
			
		},
		// 导出
		exportButton(){
			this.r_export = "1"
			this.searchButton('export')
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		plRequest(e){
			let that = this
			
			// 把相同adv_id的进行归类，分批次请求
			let arr = []
			this.selectedData.forEach(res=>{
				if(arr.length > 0){
					let ttt = true
					arr.forEach(res_z=>{
						if(res.adv_id == res_z){
							ttt = false
						}
					})
					if(ttt){
						arr.push(res.adv_id)
					}
				}
				else {
					arr.push(res.adv_id)
				}
			})
			console.log('this.selectedData',this.selectedData);
			let r_arrys = []
			arr.forEach(res=>{
				let obj = {
					o_adv_id: res,
					o_group_ids: []
				}
				this.selectedData.forEach(res_z=>{
					if(res_z.adv_id == res){
						obj.o_group_ids.push(res_z.id)
					}
				})	
				r_arrys.push(obj)
			})
			
			console.log('r_arrys',r_arrys);
			
			
				let r_opt_status
				
				if(e.key == '1'){ // 开启
					r_opt_status = "AD_STATUS_NORMAL"
				}
				else if(e.key == '2'){ // 暂停
					r_opt_status = "AD_STATUS_SUSPEND"
				}
				
				let promise_arr = []
				for(let i = 0; i < r_arrys.length ; i ++){
					let ppp = new Promise((resolve,reject)=>{
						JLjhEditStatus({
							adv_id: r_arrys[i].o_adv_id,
							plan_ids: r_arrys[i].o_group_ids,
							opt_status: r_opt_status,
						}).then(res=>{
							console.log('开启/暂停/删除',res);
							if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){  // 8011表示内容为空
								resolve('OK')
							}
							else if(res.data.code === 401){ // 未登录
								reject('err')
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								reject('err')
								that.$message.error(`其他错误：${res.data.msg}`);
							}
						}).catch(err=>{
							reject('err')
						})
					})
					promise_arr.push(ppp)
				}
				// console.log("promise_arr",promise_arr)
				// 等待请求全部完成
				const result = Promise.all(promise_arr).then(res=>{
					// console.log('resultresult',res);
					that.search_button_loading = false
					
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					if(e.key == '1'){ // 开启
						that.$message.success('开启成功');
					}
					else if(e.key == '2'){ // 暂停
						that.$message.success('暂停成功');
					}
					else if(e.key == '3'){ // 删除
						that.dl_loading = false
						that.dl_modal = false
						that.$message.success('删除成功');
					}
					
					that.searchButton()
					
				}).catch(err=>{
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					that.checkAll = false
					that.indeterminate = false
					
					that.dl_loading = false
					
					that.search_button_loading = false
					that.$message.error('请求失败，请刷新页面再试')
				})
				console.log("result",result); 
			
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
		    console.log('click', e);
			if(this.selectedData.length > 0){
				let that = this
				if(e.key == '1' || e.key == '2'){ // 开启
					that.search_button_loading = true
					
					// console.log(this.selectedData);
					that.plRequest(e)
				}
				
				else if(e.key == '3'){ // 删除
					this.dl_modal = true
				}
				else if(e.key == '5'){ // 修改回传参数
					// this.h_type_pl = 1
					// this.hc_visible = true
					this.$refs.txHcRef.plHcHandle(this.selectedData)
				}
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		// 全部/只看消耗/只看显示
		handleMenuClickB(e){
			
			if(e.key != this.type_button_key){ // 避免重复点击
				console.log(e);
				if(e.key == '1'){ // 全部
					this.have_cost = "", // 消耗
					this.have_show = "", // 展示
					this.type_button_key = e.key
					this.type_button_text = "全部"
					this.searchButton()
				}
				else if(e.key == '2'){ // 消耗
					this.have_cost = "1", // 消耗
					this.have_show = "", // 展示
					this.type_button_key = e.key
					this.type_button_text = "只看有消耗"
					this.searchButton()
				}
				else if(e.key == '3'){ // 展示
					this.have_cost = "", // 消耗
					this.have_show = "1", // 展示
					this.type_button_key = e.key
					this.type_button_text = "只看有展示"
					this.searchButton()
				}
			}
		},
		// 开启、暂停按钮点击
		statusCheckbox(e,item){
			// console.log('qqq',e,item);
			// item.status_checked = e
			this.selectedData.push(item)
			if(item.status == 'AD_STATUS_NORMAL'){ // 启用
				// console.log('启用');
				this.plRequest({key: "2"}) // 当前为开启状态就要改为暂停状态
			}
			else { // 暂停
				// console.log('暂停');
				this.plRequest({key: "1"}) // 当前为暂停状态就要改为开启状态
			}
			
		},
		
		
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			// console.log(that.r_sort_field);
			// console.log(that.r_sort_type);
			that.r_page = 1
			that.searchButton()
		},
		
		
		// 批量删除确认
		dlOk(){
			let that = this
			
			that.dl_loading = true
			that.plRequest({key:"3"})
		},
		// 删除弹窗取消
		dlCancel(){
			if(this.dl_loading){
				return
			}
			
			this.dl_modal = false
		},
		
		
		// 回传比例侧边栏开始
		setPlanHcbl(e){
			this.$refs.txHcRef.setPlanHcbl(e)
		},
		// 回传侧边栏组件确认按钮 传递过来 的要执行的操作
		hcRequestD(r_data){
			let that = this
			MPggReportConfig(r_data).then(res=>{
				
				that.$refs.txHcRef.closeLoading()
				
				console.log('批量设置回传',res)
				if(res.data.code == 0){
					
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					that.$refs.txHcRef.hcCloseDrawer()
					
					that.$message.success('设置成功');
					that.searchButton()
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			})
			.catch(err=>{
				that.$refs.txHcRef.closeLoading()
				// that.hc_button_loading = false
				// that.hcCloseDrawer()
				that.$message.error('设置失败，请检查网络状态')
			})
		},
		
		
		// 表格内的操作按钮
		tdHandle(e,item){
			console.log("表格内的操作按钮",e,item)
			this.h_drawer_name = item.adgroup_name
			this.h_drawer_id = item.adgroup_id
			if(e == 8){ // 小时数据
				// 控制子组件的事件
				this.$refs.getDrawerHour.getTableData(item.adgroup_id)
			}
			else if(e == 9){ // 天数据
				this.$refs.getDrawerDay.getTableData(item.adgroup_id)
			}
		},
		// 获取小时数据的加载状态控制
		hourLoadingHandle(e){
			console.log("获取小时数据的加载状态控制",e)
			this.search_button_loading = e
		},
		// 获取小时数据侧边栏关闭
		hourDrawerClose(e){
			this.h_drawer_name = ""
			this.h_drawer_id = ""
		},
	},
	filters: {
		dayToFixed(e){ // 保留小数点后两位，四舍五入
			console.log("过滤器",e)
			if(Object.keys(e).length > 0){
				if(e.charge_money){ // 有时候charge_money字段的值为null
					let v = (Number(e.charge_money)/Number(e.cost))*1.06*100
					return v.toFixed(2)
				}
				else {
					return '-'
				}
				
			}
			else {
				return '-'
			}
			
		}
	}
}
</script>

<style scoped>
.day-data-a {
	font-size: 16px;
	font-weight: 800;
}
.day-data-b {
	font-size: 13px;
}
.day-data-c {
	font-size: 13px;
	margin-top: 5px;
}
.day-data-e {
	display: flex;
	align-items: flex-end;
}

/* 侧边栏样式 */
.form-cell-box {
	margin-bottom: 20px;
}
.class-title {
	width: 115px;
}
</style>